import { v5 as uuidv5 } from 'uuid';

/**
 * Fixed namespace so a given ordered pair of ids always maps to the same id.
 * Concurrent offline writes of the same relation (project↔user, group↔user,
 * project↔group) then converge onto one row instead of duplicating.
 */
const PAIR_NS = '6f9b1f1e-3d2a-5c4b-8e7a-1b2c3d4e5f60';

/** Deterministic id for an ordered (owner, member) relation pair. */
export function pairId(owner: string, member: string): string {
    return uuidv5(`${owner}:${member}`, PAIR_NS);
}
